import { useChat } from '../contexts/ChatContext'

export default function ErrorBanner() {
  const { errorMessage } = useChat()

  if (!errorMessage) return null

  return (
    <div className="px-4 mt-3 animate-fade-in">
      <div className="max-w-4xl mx-auto bg-destructive/10 text-destructive border border-destructive/30 px-5 py-4 rounded-2xl shadow-md text-sm leading-relaxed">
        <div className="text-center">
          <span className="font-medium">⚠️ {errorMessage.message || 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.'}</span>
        </div>
      </div>
    </div>
  )
}
